// QR Menü Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrMenuSettings';

export const qrMenuSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'QR menü ayarları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencerede bir QR menünün ürünlerini, görünümünü, mutfak personelini ve yazdırma ayarlarını düzenlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.products`, 'Ürünler'),
    t(`${G}.nav.templates`, 'Şablonlar'),
    t(`${G}.nav.extra`, 'Ek Ayarlar'),
    t(`${G}.nav.personnel`, 'Personel'),
    t(`${G}.nav.printing`, 'Yazdırma'),
    t(`${G}.nav.kitchen`, 'Mutfak Ekranı'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Sekme içeriği'),
    footer: t(`${G}.regions.footer`, 'Şablon ve kaydet'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Ürünler ve menüler'),
      text: t(`${G}.s1.text`, '"Menü Ekle" ile menü içinde başlıklar (ör. Tatlılar, İçecekler) oluşturun ve her başlığa "Bu Menüye Ürün Ekle" ile stok kartlarınızdan ürün seçin. "Menüsüz Ürün Ekle" ürünü başlıksız genel listeye koyar. Ürünlere resim ekleyebilir, oklarla sıralarını değiştirebilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Bir menü başlığını silmek içindeki tüm ürünleri de menüden kaldırır; bu işlem geri alınamaz.'),
        t(`${G}.s1.tip2`, 'Online bilet sayfasında bu sekmenin adı "Biletler"dir ve "Bilet Türü Ekle" düğmesi kullanılır.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Şablonlar ve Ek Ayarlar'),
      text: t(`${G}.s2.text`, '"Şablonlar" sekmesinde menünün müşteriye görünüşünü seçin (Standart, Modern, Liste, Karma, Carousel, QrTık). "Ek Ayarlar" sekmesinde menü adını, yazı tipini, renkleri ve fiyat / resim / açıklama / logo gösterimi, sipariş notu, sepet düğmesi gibi seçenekleri ayarlayın.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s3.title`, '3. Personel'),
      text: t(`${G}.s3.text`, 'Bu menünün siparişlerini görecek mutfak personelini seçin. Soldan bir personel seçip sağda yetkilerini açın: Mutfak Ekranına Erişim, Tüm Siparişleri Görme, Sipariş Durumu Güncelleme, Sipariş İptal Etme, Yazdırma Butonu Göster, Garson Modu, Otomatik Yazdırma, Fiyatları Göster vb.'),
      tips: [
        t(`${G}.s3.tip1`, '"Fiyatları Göster" kapalıysa personel hiçbir yerde fiyat görmez.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s4.title`, '4. Yazdırma'),
      text: t(`${G}.s4.text`, '"Tek Yazıcı Kullan" seçilirse tüm adisyonlar varsayılan yazıcıya gider. "Kategori Bazlı Yazıcı" seçilirse her ürün kategorisine ayrı yazıcı atanır. Yazıcıları görmek için "Yerel Yazıcıları Yenile"ye basın; "Test" ile deneme çıktısı alın. "Adisyon Yazdırma Ayarları" fişte nelerin görüneceğini belirler, "Fiş No Sıfırla" adisyon numarasını baştan başlatır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Yazıcı listesi boşsa yerel servis (GTS masaüstü yazılımı) çalışmıyor olabilir.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s5.title`, '5. Mutfak Ekranı'),
      text: t(`${G}.s5.text`, 'Mutfak ekranındaki sipariş kartlarının bekleme süresine göre renklerini ayarlayın: süre aralıklarını dakika olarak girin (Yeni, Normal, Gecikme, Kritik) ve Hazırlanıyor / Hazır / Teslim / İptal durumlarının renklerini seçin.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Şablon kaydet / uygula ve kaydet'),
      text: t(`${G}.s6.text`, '"Ayarları Şablon Olarak Kaydet" ürünleri, alt menüleri, sıralamayı, görünüm ve mutfak renklerini saklar; "Şablon Seç ve Uygula" bunları başka bir menüye aktarır ve mevcut ayarların yerine geçer. Personel ve yazdırma ayarları şablona dahil edilmez. Yaptığınız değişiklikler ancak "Değişiklikleri Kaydet" ile kalıcı olur.'),
      tips: [
        t(`${G}.s6.tip1`, 'Şablonlar bu tarayıcıda saklanır; başka bilgisayarda görünmez.'),
        t(`${G}.s6.tip2`, 'Değişiklik yoksa "Değişiklikleri Kaydet" pasif kalır.'),
      ],
    },
  ],
});
